export default __webpack_public_path__ + "static/media/flechaCurva2.092c8159.svg";